module.exports = __webpack_public_path__ + "img/projects_icon.48734951.svg";